// extracted by mini-css-extract-plugin
export default {"tooltip":"ip-z","sharingV2":"jp-z","sharingIconsV2":"kp-z","links":"lp-z","link":"mp-z","facebookV2":"np-z","twitterV2":"op-z","pinterestV2":"pp-z"};